<template>
  <div class="v-table-td-number-edit">
    <div class="v-table-td-number-edit-tip" >
      <template v-if="hasWb && currency && currency.id!=localCurrency.id">
        <div style="line-height: 40px;font-size:20px;display:flow-root;"><span style="font-size:10px;float:left;">本位币：</span>{{ numFormat(bwbNumber) }}</div>
        <div style="line-height: 15px;font-size:14px;display:flow-root;font-weight:500;"><span style="font-size:10px;float:left;">原　币：</span>{{ numFormat(ybNumber) }}</div>
      </template>
      <template v-else>
        {{ numFormat(inputNumber) }}
      </template>
<!--      <Form style="padding:5px;top:64px;left:-1px;" class="currency-selector">-->
<!--        <FormItem class="!pb-5px"  label="币　　种">-->
<!--          <Select v-model="currency" :datas="currencyList" keyName="id" titleName="name" :deletable="false">-->
<!--            <template v-slot:item="{ item }">-->
<!--              {{ item.code }} {{ item.name }}-->
<!--            </template>-->
<!--          </Select>-->
<!--        </FormItem>-->
<!--        <FormItem class="!pb-5px" label="汇　　率">-->
<!--          <Input />-->
<!--        </FormItem>-->
<!--        <FormItem class="!pb-5px" label="原币金额">-->
<!--          <Input />-->
<!--        </FormItem>-->
<!--        <FormItem class="!pb-5px" label="本币金额">-->
<!--          <Input />-->
<!--        </FormItem>-->
<!--      </Form>-->

    </div>
    <div class="v-table-td-number-edit">
      <span class="currency-icon " @mousedown.native="showCurrencySelector" v-if="hasWb">
        <svg t="1727060775903" class="icon" style="margin:0 auto;" viewBox="0 0 1090 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="10135" width="15" height="15"><path d="M842.124387 0a234.892387 234.892387 0 0 1 234.859355 234.892387V789.140645A234.892387 234.892387 0 0 1 842.157419 1024H256.660645a234.892387 234.892387 0 0 1-234.859355-234.892387V234.859355A234.892387 234.892387 0 0 1 256.660645 0h585.463742zM805.656774 195.716129a3311.186581 3311.186581 0 0 1-248.336516 22.197677c-44.395355 2.312258-88.526452 4.062968-132.459355 5.219097-43.932903 1.156129-84.892903 1.255226-122.813935 0.330323-11.098839 0-20.116645 0.594581-27.05342 1.750709-6.936774 1.156129-12.354065 3.336258-16.284903 6.606452a22.82529 22.82529 0 0 0-7.630451 13.873548c-1.156129 5.978839-1.75071 13.873548-1.75071 23.552 0 5.549419 0.594581 10.53729 1.75071 14.930581a20.876387 20.876387 0 0 0 7.267096 11.098839c3.699613 2.972903 8.786581 5.186065 15.260904 6.606451 6.474323 1.354323 15.260903 2.048 26.359741 2.048 26.359742 0.462452 58.268903 0.132129 95.727484-1.024 37.458581-1.156129 77.229419-2.906839 119.312516-5.219096V386.477419h-148.446967c-15.723355 0-28.672 1.519484-38.845936 4.52542a52.620387 52.620387 0 0 0-24.278709 14.203871 53.347097 53.347097 0 0 0-12.486194 25.335742c-2.312258 10.405161-3.468387 22.792258-3.468387 37.095225v283.020388c0 16.648258 2.77471 27.978323 8.324129 34.023225 5.549419 5.978839 16.648258 8.984774 33.296516 8.984775 17.573161 0 28.903226-2.972903 34.023226-9.017807 5.053935-6.011871 7.597419-17.341935 7.597419-33.990193v-268.453162c0-4.162065 0.693677-7.267097 2.081033-9.348129 1.387355-2.081032 4.162065-3.138065 8.324129-3.138064h133.879741v337.127225c0 16.648258 3.138065 27.747097 9.381162 33.296517 6.243097 5.549419 16.747355 8.324129 31.545806 8.324129 15.260903 0 26.128516-2.972903 32.602839-9.017807 6.474323-6.011871 9.711484-16.846452 9.711484-32.602839V469.71871h137.348129c4.624516 0 7.531355 1.156129 8.687484 3.468387 1.156129 2.312258 1.717677 5.318194 1.717677 9.017806v211.571613c0 6.936774-2.312258 10.405161-6.936774 10.405161-6.011871 0-12.717419-0.660645-20.116645-2.081032a120.53471 120.53471 0 0 1-24.27871-7.597419c-16.648258-6.044903-29.596903-8.125935-38.845935-6.276129-9.249032 1.849806-17.11071 10.173935-23.585033 24.972387-6.474323 13.411097-7.498323 24.774194-3.105032 34.023226s13.741419 17.308903 28.077419 24.245677a303.764645 303.764645 0 0 0 48.55742 13.873548c14.798452 2.77471 27.978323 4.624516 39.539613 5.54942 25.89729 1.849806 46.37729-2.642581 61.406967-13.543226 15.029677-10.834581 22.528-31.050323 22.528-60.680258V469.71871c0-28.209548-5.41729-49.118968-16.284903-62.761291-10.900645-13.642323-31.347613-20.48-61.406968-20.48h-153.269677V293.524645c43.437419-2.312258 84.034065-4.954839 121.723871-7.960774a1975.097806 1975.097806 0 0 0 93.976774-9.381161c22.197677-2.77471 36.996129-7.399226 44.395355-13.873549 7.399226-6.474323 10.173935-16.417032 8.324129-29.828129a80.730839 80.730839 0 0 0-4.492387-19.75329 27.152516 27.152516 0 0 0-9.381161-12.486194c-4.162065-3.005935-10.041806-4.855742-17.672258-5.549419a149.140645 149.140645 0 0 0-29.497807 1.024z" fill="#2c2c2c" p-id="10136"></path></svg>
<!--        <svg t="1725952878298" class="icon" style="margin:0 auto;" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12753" width="15" height="15"><path d="M874.666667 512c0-183.146667-135.744-334.570667-312.106667-359.168l-35.2-88.576C767.68 72.362667 960 269.717333 960 512h-85.333333zM488.192 873.898667l34.133333 85.973333c-3.434667 0.085333-6.869333 0.128-10.325333 0.128-247.424 0-448-200.576-448-448h85.333333c0 192.298667 149.653333 349.632 338.858667 361.898667z m-27.562667-106.112L522.368 960l-189.482667-38.186667 127.744-154.026666z m128.853334-511.232l-61.717334-192.213334 189.482667 63.786667-127.744 128.426667z m-327.509334 27.733333H149.333333V213.333333h89.813334L128 64h82.709333L298.666667 187.562667 386.624 64H469.333333l-111.146666 149.333333h82.389333v70.954667H335.36V341.333333h105.216v70.954667H335.36V512h-73.386667v-99.712H149.333333V341.333333h112.64v-57.045333z m460.629334 212.181333c23.829333 4.245333 43.541333 12.650667 58.88 24.704 23.253333 17.877333 37.461333 47.466667 43.136 88.256H759.893333c-3.413333-23.466667-11.946667-39.68-25.557333-49.152a54.826667 54.826667 0 0 0-11.733333-6.378666v125.610666c30.677333 11.114667 47.573333 17.450667 50.346666 19.285334C812.117333 720.554667 832 751.850667 832 792.618667c0 39.68-15.338667 69.269333-45.994667 89.386666-17.621333 11.264-38.677333 18.816-63.402666 22.698667V960h-70.976v-53.930667c-33.173333-3.904-58.986667-14.229333-77.418667-31.36-23.850667-22.314667-37.461333-56.384-40.874667-102.186666h65.856c2.282667 29.034667 9.664 50.261333 22.72 62.549333 7.509333 6.954667 17.408 11.861333 29.717334 14.762667v-132.714667l-54.122667-19.456c-39.765333-21.226667-59.050667-52.48-59.050667-93.824 0-36.864 14.186667-64.789333 43.136-84.352 19.093333-13.333333 42.176-21.418667 70.037334-24.661333V448h70.976v48.469333z m0 350.293334c6.997333-2.304 13.418667-5.248 19.114666-8.896 15.893333-10.048 23.850667-24.576 23.850667-43.008 0-21.418667-14.442667-38.784-42.965333-51.754667v103.658667z m-70.976-296.981334c-9.706667 2.069333-17.792 5.269333-24.042667 9.386667-15.317333 8.917333-22.698667 24-22.698667 44.672 0 19.072 15.573333 35.413333 46.741334 49.066667v-103.125334z" fill="#555" p-id="12754"></path></svg>-->
<!--        <svg t="1727061053845" class="icon" style="margin:0 auto;" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12479" width="15" height="15"><path d="M511.801208 0C234.575576 0.513529-6.292221 236.303098 0.82871 513.528729c7.668696 291.558789 213.285599 509.956852 516.096373 510.470381 287.964088 0.513529 509.443323-219.938649 506.373563-513.528729C1020.742414 217.382417 805.4027 13.842452 511.801208 0z m2.556232 957.502845C282.15116 971.824591 65.27086 756.484877 66.297918 511.999555c0.513529-238.357213 207.157489-444.487645 445.058232-445.001173 239.886387-1.015646 449.08658 210.740779 448.573051 448.070934-0.057059 235.789569-210.284309 456.755275-445.571761 442.433529z" fill="#0B0015" p-id="12480"></path><path d="M695.404846 237.843684a33.79019 33.79019 0 0 0-28.129962 15.337391l-57.800512 87.471061-89.011646 132.981117-92.058584-138.082169-53.201576-80.818011a10.886809 10.886809 0 0 0-2.042703-3.06976l-0.513529-1.027058a34.235249 34.235249 0 0 0-26.600788-12.781159 33.185368 33.185368 0 0 0-33.242427 33.242426 30.903018 30.903018 0 0 0 4.5647 16.877978c0.513529 0.513529 1.027057 1.540586 1.540586 2.054115l128.95277 194.867035h-71.095199a33.504897 33.504897 0 0 0 0 67.009793h109.963618v42.965237h-109.952207a33.504897 33.504897 0 0 0 0 67.009793h109.963619v115.5782a36.038305 36.038305 0 0 0 0.513529 7.668695c0 18.418564 14.835274 33.767367 33.242426 33.767367A33.299485 33.299485 0 0 0 553.750799 785.128368a38.526066 38.526066 0 0 0 0.513529-7.668695V661.870062h109.45009a33.185368 33.185368 0 0 0 33.253838-33.253838c0-18.407152-14.835274-33.755955-33.253838-33.755956h-109.45009v-41.938179h109.45009a33.185368 33.185368 0 0 0 33.253838-33.253838c0-18.407152-14.835274-33.755955-33.253838-33.755956h-71.0952l128.95277-194.878446a11.115044 11.115044 0 0 0 1.540586-2.556232 32.169722 32.169722 0 0 0 4.5647-16.877978 31.850193 31.850193 0 0 0-32.272428-33.755955z" fill="#0B0015" p-id="12481"></path></svg>-->
        <span style="font-size:10px;position:relative;top:-3px;">{{ currency.name }}</span>
      </span>
      <input v-model.number="inputNumber" @keydown="onKeyDown" class="v-table-td-number-edit-textarea"
             ref="textarea" :onfocus="inputFocus" />
      <span class="edit-icon" @mousedown.native="showCalculator">
        <svg t="1619668798051" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
               p-id="2232" width="15" height="15" data-spm-anchor-id="a313x.7781069.0.i7"
               xmlns:xlink="http://www.w3.org/1999/xlink"><defs></defs><path
                  d="M72 112.197v799.604c0 22.215 17.987 40.198 40.198 40.198h799.604c22.215 0 40.198-17.987 40.198-40.198V112.197c0-22.215-17.987-40.198-40.198-40.198H112.198C89.983 71.999 72 89.986 72 112.197z m220 591.519l-70.613-70.613c-7.652-7.652-20.571-7.907-28.381-0.097-7.583 7.582-7.767 20.517 0.097 28.381L263.716 732l-70.613 70.613c-7.652 7.652-7.907 20.571-0.097 28.381 7.582 7.583 20.517 7.767 28.381-0.097L292 760.284l70.613 70.613c7.652 7.652 20.571 7.907 28.381 0.097 7.582-7.582 7.767-20.517-0.097-28.381L320.284 732l70.613-70.613c7.652-7.652 7.907-20.571 0.097-28.381-7.582-7.582-20.517-7.767-28.381 0.097L292 703.716zM272 272h-99.863C161.316 272 152 280.954 152 292c0 10.722 9.016 20 20.137 20H272v99.863c0 10.821 8.954 20.137 20 20.137 10.723 0 20-9.016 20-20.137V312h99.863c10.821 0 20.137-8.954 20.137-20 0-10.722-9.016-20-20.137-20H312v-99.863c0-10.821-8.954-20.137-20-20.137-10.722 0-20 9.016-20 20.137V272zM32 112.197C32 67.905 67.881 32 112.197 32h799.604c44.292 0 80.197 35.881 80.197 80.197v799.604c0 44.292-35.881 80.197-80.197 80.197H112.197C67.905 991.998 32 956.117 32 911.801V112.197zM552 292c0-11.046 9.316-20 20.137-20h239.726c11.122 0 20.137 9.278 20.137 20 0 11.046-9.316 20-20.137 20H572.137C561.015 312 552 302.722 552 292z m0 360c0-11.046 9.316-20 20.137-20h239.726c11.122 0 20.137 9.278 20.137 20 0 11.046-9.316 20-20.137 20H572.137C561.015 672 552 662.722 552 652z m0 160c0-11.046 9.316-20 20.137-20h239.726c11.122 0 20.137 9.278 20.137 20 0 11.046-9.316 20-20.137 20H572.137C561.015 832 552 822.722 552 812z"
                  p-id="2233"></path></svg>
      </span>
    </div>
  </div>
  <div v-if="calculateStatus" class="calculator" @mousedown.native="noInputData">
    <div class="result" style="grid-area:result;">
      <span class="result-info">{{ equation }}</span>
    </div>
    <button style="grid-area:ac" @click="clear">C</button>
    <button style="grid-area:plus-minus" @click="calculateToggle">±</button>
    <button style="grid-area:percent" @click="calculatePercentage">%</button>
    <button style="grid-area:add" @click="append('+')">+</button>
    <button style="grid-area:subtract" @click="append('-')">-</button>
    <button style="grid-area:multiply" @click="append('×')">×</button>
    <button style="grid-area:divide" @click="append('÷')">÷</button>
    <button style="grid-area:equal" @click="calculate">=</button>
    <button style="grid-area:number-1" @click="append(1)">1</button>
    <button style="grid-area:number-2" @click="append(2)">2</button>
    <button style="grid-area:number-3" @click="append(3)">3</button>
    <button style="grid-area:number-4" @click="append(4)">4</button>
    <button style="grid-area:number-5" @click="append(5)">5</button>
    <button style="grid-area:number-6" @click="append(6)">6</button>
    <button style="grid-area:number-7" @click="append(7)">7</button>
    <button style="grid-area:number-8" @click="append(8)">8</button>
    <button style="grid-area:number-9" @click="append(9)">9</button>
    <button style="grid-area:number-0" @click="append(0)">0</button>
    <button style="grid-area:dot" @click="append('.')">.</button>
    <button style="grid-area:canceld" @click="cancelData">取消</button>
    <button style="grid-area:enterd" @click="enterData">确定</button>
  </div>

  <div v-if="currencySelector" class="currency-selector">
<!--    <div v-for="item in currencyList" :key="item.id" >-->
<!--      <div @click="selectCurrency(item)" :class="'currency-item' + ((item.id===currency.id)?' currency-item-selected':'')">-->
<!--        <Row>-->
<!--          <Cell width="16">{{ item.code}} {{ item.name}}</Cell>-->
<!--          <Cell width="8">汇率：{{ item.exchangeRate}}</Cell>-->
<!--        </Row>-->
<!--      </div>-->
<!--    </div>-->
    <Form style="padding:5px;">
      <FormItem class="!pb-5px"  label="币　　种">
        <Select className="currencySelect" v-model="currency" :datas="currencyList" type="object" keyName="id" titleName="name" :deletable="false">
          <template v-slot:item="{ item }">
            {{ item.code }} {{ item.name }}
          </template>
        </Select>
      </FormItem>
      <FormItem class="!pb-5px" label="汇　　率">
        <Input v-model.number="exchangeRate" @keydown="onKeyDown" :onfocus="exchangeFocus"/>
      </FormItem>
      <FormItem class="!pb-5px" label="原币金额">
        <Input v-model.number="ybNumber" @keydown="onKeyDown" ref="ybtextarea" :onfocus="ybFocus"/>
      </FormItem>
      <FormItem class="!pb-5px" label="本币金额">
        <Input v-model.number="bwbNumber" @keydown="onKeyDown" :onfocus="bwbFocus"/>
      </FormItem>
    </Form>
  </div>
</template>

<script setup>
  import {defineEmits, defineProps, getCurrentInstance, h, nextTick, onMounted, ref, watch, watchEffect } from "vue";
  import {getVTable} from "@components/VoucherTable/VtUtil";
  import {isNumber, toNumber} from "xe-utils";
  import {useStore} from "vuex";

  const emits = defineEmits(['cancelEdit', 'onNext']);

  const props = defineProps({
    number: {
      type: [Number, String]
    },
    numberFor: {
      type: [Number, String]
    },
    exchangeRate: {
      type: [Number, String]
    },
    readonly: {
      type: Boolean,
      default: false
    },
    originCurrencyId:[String, null],
    rowIndex: Number,
    field: String,
    subject: Object,
  });

  const store = useStore();
  const {localCurrency} = store.getters

  const currencyMap = store.state.currencyMap;

  let currencyList = [];
  for (let key in currencyMap) {
    currencyList.push(currencyMap[key]);
  }
  // 将Map转换为数组
  // console.log(currencyMap.values)
  // const currencyList = Array.from(currencyMap.values());

  // 按照id属性排序
  currencyList.sort((a, b) => a.id - b.id);

  const currencyId = ref(null);
  const textarea = ref(null)
  const ybtextarea = ref(null)
  const inputNumber = ref(null)
  const bwbNumber = ref(null)
  const ybNumber = ref(null)
  const exchangeRate = ref(null)
  const currentTextArea = ref(null)
  let VTable = null

  const calculateStatus = ref(false)
  const currencySelector = ref(false)
  const equation = ref('0')
  const isDecimalAdded = ref(false)
  const isOperatorAdded = ref(false)
  const isStarted = ref(false)
  const currency = ref(null);

  if(props.originCurrencyId){
    currency.value =currencyMap[props.originCurrencyId]
    exchangeRate.value = currencyMap[props.originCurrencyId].exchangeRate;
  }else if(currencyList.length>0){
    currency.value =currencyList[0]
    exchangeRate.value = currencyList[0].exchangeRate;
  }



  let hasWb = ref(false)
  if(props.subject && props.subject.currencyAccounting && props.subject.currencyAccounting.length){
    hasWb.value = true;
    let fCurrencyId = props.subject.currencyAccounting[0]
    currencySelector.value = true
    if(!props.originCurrencyId){
      currency.value = currencyMap[fCurrencyId];
      exchangeRate.value = currencyMap[fCurrencyId].exchangeRate;
    }

  }

  const contains = (root, n) =>{
    let node = n;
    while (node) {
      if (node === root) {
        return true;
      }
      node = node.parentNode;
    }
    return false;
  }

  const clickOutside = (e) =>{
    const target = e.target;
    const container1 = document.getElementsByClassName("currency-selector")[0];
    const container2 = document.getElementsByClassName("v-table-td-number-edit")[0];
    const container3 = document.getElementsByClassName("currencySelect-dropdown")[0];
    const container4 = document.getElementsByClassName("calculator")[0];


    if(contains(container1,target) || contains(container2,target) || contains(container3,target) || contains(container4,target)){
    }else{
      onBlur();
      window.document.removeEventListener('mousedown',clickOutside,false)
    }
  }
  window.document.addEventListener('mousedown', clickOutside, false)

  const bwbFocus = () =>{
    currentTextArea.value = "bwbNumber"
  }
  const exchangeFocus = () =>{
    currentTextArea.value = "exchangeRate"
  }
  const ybFocus = () =>{
    currentTextArea.value = "ybNumber"
  }
  const inputFocus = () =>{
    currentTextArea.value = "inputNumber"
  }



  const onKeyDown = (e) => {
    if ((e.keyCode >= 48 && e.keyCode <= 57) || (e.keyCode >= 96 && e.keyCode <= 105) || [190, 110].includes(e.keyCode)) {
      //先拼接出下一个输入值
      let numStr = insertStr(e.target.value, getCursorPosition(e.target), e.key);
      let num = Number(numStr);
      //判断是否是数字
      if (typeof num === 'number' && !isNaN(num)) {
        if (numStr.indexOf('.') !== -1) {
          //不能超过两位小数
          if (numStr.split('.')[1].length > 2) {
            e.preventDefault();
          }
        }
        //不能超过最大值
        if (num > 9999999999.99) {
          e.preventDefault();
        }
      } else {
        e.preventDefault();
      }
    } else if (e.keyCode === 13 || e.keyCode === 9) {//回车
      const params = {
        number: bwbNumber.value,
        numberFor: ybNumber.value,
        originCurrency: currency.value,
        exchangeRate: exchangeRate.value
      }
      emits('onNext', params)
      e.preventDefault();
    } else if (e.key === '=') {//等于
      VTable.exposed.autoEqAmount(props.rowIndex, props.field);
      e.preventDefault();
    } else if (e.key === '+') {//加
      e.preventDefault();
    } else if (e.key === '-') {//减
      if (e.target.value.length) {
        e.preventDefault();
      }
    } else if (e.keyCode === 8) {//删除

    } else if (e.keyCode === 32) {//空格
      VTable.exposed.next(props.rowIndex, props.field === 'debitAmount' ? 'creditAmount' : 'debitAmount');
    } else if ([37, 39].includes(e.keyCode)) {//左右移动

    } else {
      e.preventDefault();
    }
  }

  const onBlur = (e) => {
    const params = {
      number: bwbNumber.value,
      numberFor: ybNumber.value,
      originCurrency: currency.value,
      exchangeRate: exchangeRate.value
    }
    emits('cancelEdit', params)

  }

  const getCursorPosition = (element) => {
    let startPos = element.selectionStart; // 获取光标开始的位置
    let endPos = element.selectionEnd; // 获取光标结束的位置
    if (startPos === undefined || endPos === undefined) return 0; // 如果没有光标位置 不操作
    return {startPos, endPos};
  }

  const insertStr = (source, pos, newStr) => {
    if (pos.startPos === pos.endPos) {
      return source.slice(0, pos.endPos) + newStr + source.slice(pos.endPos)
    }
    return source.slice(0, pos.startPos) + newStr + source.slice(pos.endPos)
  }

  const showCalculator = (event) => {
    event.preventDefault();
    if (calculateStatus.value) {
      calculateStatus.value = false
    } else {
      currencySelector.value = false
      calculateStatus.value = true
    }
    if (inputNumber.value !== '' && inputNumber.value !== null) equation.value = inputNumber.value
  }

  const showCurrencySelector = (event) => {
    event.preventDefault();
    // if (currencySelector.value) {
    //   currencySelector.value = false
    // } else {
    //   calculateStatus.value = false
    //   currencySelector.value = true
    // }
    calculateStatus.value = false
    currencySelector.value = true
  }

  const selectCurrency = (item) => {
    currency.value = item;
    // currencySelector.value = false
  }

  //输入+ - x /
  const isOperator = (character) => {
    return ["+", "-", "×", "÷"].indexOf(character) > -1;
  }

  // operators or Numbers
  const append = (character) => {
    //首次输入时不为操作符
    if (equation.value === "0" && !isOperator(character)) {
      if (character === ".") {
        equation.value += "" + character; //引号的作用将其转换成字符串
        isDecimalAdded.value = true;
      } else {
        equation.value = "" + character;
      }
      isStarted.value = true;
      return;
    }

    //if NUmber
    if (!isOperator(character)) {
      //防止连续输入.
      if (character === "." && isDecimalAdded.value) {
        return;
      }
      if (character === ".") {
        isDecimalAdded.value = true;
        isOperatorAdded.value = true;
      } else {
        isOperatorAdded.value = false;
      }
      equation.value += "" + character;
    }

    //Add Operator
    if (isOperator(character) && !isOperatorAdded.value) {
      equation.value += "" + character;
      isDecimalAdded.value = false;
      isOperatorAdded.value = true;
    }
  }

  //=
  const calculate = () => {
    let result = equation.value
            .replace(new RegExp("×", "g"), "*")
            .replace(new RegExp("÷", "g"), "/");

    equation.value = parseFloat(eval(result).toFixed(9)).toString();
    isDecimalAdded.value = false;
    isOperatorAdded.value = false;
  }

  //正负号+/-
  const calculateToggle = () => {
    // if (isOperatorAdded.value || !isStarted.value) {
    //     return;
    // }
    // equation.value = equation.value + "* -1";
    // calculate();

    //得到最后一位数值
    let lastNumber = equation.value.substring(equation.value.lastIndexOf(' '))

    //得到之前的数值+符号
    let prevNumber = equation.value.substr(0, equation.value.lastIndexOf(' '))

    //判断当前是否有正负号
    if (lastNumber.indexOf('-') === -1) {
      lastNumber = ' -' + lastNumber.trim()
    } else {
      lastNumber = ' ' + lastNumber.trim().substr(1)
    }

    //合并
    equation.value = prevNumber + lastNumber
  }

  //%
  const calculatePercentage = () => {
    if (isOperatorAdded.value || !isStarted.value) {
      return;
    }
    equation.value = equation.value + "* 0.01";
    calculate();
  }

  //AC
  const clear = () => {
    (equation.value = "0"),
            (isDecimalAdded.value = false),
            (isOperatorAdded.value = false),
            (isStarted.value = false);
  }

  //取消
  const cancelData = () => {
    (equation.value = "0"),
            (isDecimalAdded.value = false),
            (isOperatorAdded.value = false),
            (isStarted.value = false);
    onBlur()
  }

  //确认
  const enterData = (e) => {
    let eqvalue = equation.value
    if (equation.value === "0") {
      inputNumber.value = ''
    } else {
      inputNumber.value = equation.value
    }


    if(hasWb.value){
      const ecRate = parseFloat(exchangeRate.value)
      bwbNumber.value = parseFloat((eqvalue * ecRate).toFixed(2));
      ybNumber.value = inputNumber.value
    }else{
      bwbNumber.value = inputNumber.value
    }

    (isDecimalAdded.value = false),
            (isOperatorAdded.value = false),
            (isStarted.value = false);

    if(hasWb.value){
      showCurrencySelector(e)
    }else{
      onBlur()
    }

  }


  // 无效点击
  const noInputData = (event) => {
    event.preventDefault();
  }


  watch(() => props.number, (val) => {
    inputNumber.value = val;
  })
  watch(() => props.numberFor, (val) => {
    ybNumber.value = val;
  })


  watch(() => inputNumber.value, (val) => {

    if(currentTextArea.value != 'inputNumber'){
      return;
    }

    if(val === '' || val === '0'){
      bwbNumber.value = ''
      ybNumber.value = ''
    }else{
      if (!isNumber(val)){
        val = toNumber(val)
      }
      ybNumber.value = val
      if(exchangeRate.value){
        const cRate = parseFloat(exchangeRate.value)
        bwbNumber.value = parseFloat((val*cRate).toFixed(2));
      }else{
        bwbNumber.value = val
      }
    }
  })

  watch(() => exchangeRate.value, (newValue,oldValue) => {

    if(currentTextArea.value != 'exchangeRate'){
      return;
    }
    if(newValue === '' || newValue === '0'){
      return;
    }
    if(ybNumber.value == '' || ybNumber.value == '0'){
      // 原币没有输入，就不计算本位币
      return;
    }
    bwbNumber.value = parseFloat((ybNumber.value * newValue).toFixed(2));

    if(bwbNumber.value==0){
      bwbNumber.value = ''
    }
  })

  watch(() => ybNumber.value, (val) => {

    if(currentTextArea.value != 'ybNumber'){
      return;
    }

    if(val === '' || val === '0'){
      bwbNumber.value = ''
      ybNumber.value = ''
      return;
    }

    inputNumber.value = val;
    if (!isNumber(val)){
      val = toNumber(val)
    }

    if(exchangeRate.value == '' || exchangeRate.value == '0'){
      // 汇率没有输入，就不计算本位币
      return;
    }
    const cRate = parseFloat(exchangeRate.value)

    bwbNumber.value = parseFloat((val * cRate).toFixed(2));

    if(bwbNumber.value==0){
      bwbNumber.value = ''
    }

  })

  watch(() => bwbNumber.value, (val) => {

    if(currentTextArea.value != 'bwbNumber'){
      return;
    }
    if(val === '' || val === '0'){
      bwbNumber.value = ''
      return;
    }

    if(ybNumber.value == '' || ybNumber.value == '0'){
      return;
    }

    if (!isNumber(val)){
      val = toNumber(val)
    }

    let newRate = parseFloat((val / ybNumber.value).toFixed(4));
    if(newRate && newRate!=exchangeRate.value){
      exchangeRate.value = newRate
    }
    // if(!exchangeRate.value){
    //   exchangeRate.value = 1;
    // }
  })

  watch(() => currency.value, (newValue,oldValue) => {

    const oldRate = parseFloat(oldValue.exchangeRate)
    const newRate = parseFloat(newValue.exchangeRate)
    exchangeRate.value = newRate
    // if(newRate!=1){
    //   inputNumber.value = parseFloat(((inputNumber.value * 100 / newRate) / 100).toFixed(2));
    // }else{
    //   inputNumber.value = parseFloat((inputNumber.value * oldRate).toFixed(2));
    //   bwbNumber.value = inputNumber.value;
    // }
    bwbNumber.value = parseFloat((ybNumber.value * newRate).toFixed(2));

    if(bwbNumber.value==0){
      bwbNumber.value = ''
    }
  })

  onMounted(() => {
    VTable = getVTable(getCurrentInstance())

    nextTick(() => {
      if(!currency.value || currency.value.localCurrency){
        inputNumber.value = props.number;
      }else{
        inputNumber.value = props.numberFor;
      }
      if(inputNumber.value==0){
        inputNumber.value = '';
      }
      ybNumber.value = props.numberFor;
      bwbNumber.value = props.number;
      exchangeRate.rate = props.exchangeRate;
      textarea.value.focus();
      // ybtextarea.value.$el.focus();
    })
  })
</script>

<style scoped lang="less">
  .v-table {

    &-td {
      &-number {
        &-edit {
          height: 100%;
          position: relative;

          &-tip {
            position: absolute;
            height: 60px;
            width: 240px;
            top: -65px;
            background-color: @white-color;
            left: 0;
            font-weight: bold;
            font-size: 26px;
            text-align: right;
            line-height: 60px;
            padding: 0 8px;
            //border: @border;
            border: 1px solid #d3d3d3;
            z-index:102;
          }

          &-textarea {
            resize: none;
            outline: none;
            height: 100%;
            width: 100%;
            font-weight: bold;
            line-height: 60px;
            overflow: hidden;
            font-size: 20px;
            padding-right: 30px;
            text-align: right;
            float: left;
            border: 1px solid @green-color;
          }
        }
      }
    }
  }

  .currency-icon {
    //border:1px solid #ddd;
    position: absolute;
    left: 10px;
    top: 18px;
    width:40px;
    //bottom: 0;
    //height: 24px;
    //line-height: 24px;
    //width: 23px;
    font-size: 16px;
    text-align: center;
    cursor: pointer;
    user-select: none;
    z-index: 1;
    background: white;
  }


  .edit-icon {
    position: absolute;
    right: 3px;
    margin-top: -4px;
    top: 30px;
    bottom: 0;
    height: 24px;
    line-height: 24px;
    width: 23px;
    font-size: 16px;
    text-align: center;
    cursor: pointer;
    user-select: none;
    z-index: 1;
    background: white;
  }


  .currency-selector {
    z-index: 9999;
    position: absolute;
    --button-width: 50px;
    --button-height: 50px;

    box-shadow: -8px -8px 16px -10px rgba(255, 255, 255, 1),
    8px 8px 16px -10px rgba(0, 0, 0, 0.15);
    width: 220px;
    border: 1px solid @green-color;
    background-color: #fafafa;
    max-height: 300px;
    overflow-y: auto
  }

  .currency-item{
    padding: 8px 20px;
    cursor: pointer;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    //padding: 8px 10px;
    position: relative;
  }
  .currency-item.currency-item-selected{
    background-color: rgba(69,185,132,.15);
  }
  .currency-item:hover {
    background-color: #eee
  }

  .calculator {
    z-index: 9999;
    position: absolute;
    --button-width: 50px;
    --button-height: 50px;

    display: grid;
    grid-template-areas:
	"result result result result"
	"ac plus-minus percent divide"
	"number-7 number-8 number-9 multiply"
	"number-4 number-5 number-6 subtract"
	"number-1 number-2 number-3 add"
	"number-0 dot equal equal"
	"canceld canceld enterd enterd";

    grid-template-columns: repeat(4, var(--button-width));
    grid-template-rows: repeat(6, var(--button-height));

    box-shadow: -8px -8px 16px -10px rgba(255, 255, 255, 1),
    8px 8px 16px -10px rgba(0, 0, 0, 0.15);
    padding: 1px 8px;
    width: 240px;
    border: 1px solid @green-color;
    background-color: #fafafa;
  }

  .calculator button {
    margin: 5px;
    padding: 0;
    border: 0;
    display: block;
    outline: none;
    border-radius: calc(var(--button-height) / 2);
    font-size: 18px;
    font-family: Helvetica;
    color: #717070;
    background: linear-gradient(135deg,
    rgba(232, 230, 230, 1) 10%,
    rgba(246, 246, 246, 1) 100%);
  }

  .calculator button:hover {
    box-shadow: -4px -4px 10px -8px rgba(255, 255, 255, 1) inset,
    4px 4px 10px -8px rgba(0, 0, 0, 0.3) inset;
  }

  .calculator button:active {
    box-shadow: -4px -4px 10px -8px rgba(255, 255, 255, 1) inset,
    4px 4px 10px -8px rgba(0, 0, 0, 0.3) inset;
  }

  .result {
    position: relative;
    text-align: right;
    line-height: var(--button-height);
    white-space: nowrap;
    color: #666;
    overflow: hidden;
  }

  .result-info {
    display: inline-block;
    position: absolute;
    right: 0;
    top: 10px;
    transform-origin: right bottom;
    transition: transform 200ms ease-in-out;
    font-size: 20px;
    padding-right: 5px;
  }
</style>
